import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory, useParams } from 'react-router-dom';
import { PageFooter, PageHeader } from '@insurancemenu/imenu-components-lib';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import DownloadConfirmedProposalFiles from 'components/post-submit/DownloadConfirmedProposalFiles';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';

import PostSubmitDownloadProposalPageStore, {
  PostSubmitDownloadProposalPageStoreContext,
  usePostSubmitDownloadProposalPageStore,
} from 'store/pages/post-submit/post-submit-download-proposal/pageStore';
import { PageWrapperStyled } from '../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const history = useHistory();
  const { periodId } = useParams<{ periodId: string; groupId: string; cartId: string }>();
  const { getInitialData } = usePostSubmitDownloadProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  const onBack = (): void => {
    history.push(`/post-submit-checklist/${periodId}`);
  };

  return (
    <PageWrapperStyled>
      <PageHeader
        title={CARD_DATA.DOWNLOAD_CONFIRMED_PROPOSAL.title}
        subtitle={CARD_DATA.DOWNLOAD_CONFIRMED_PROPOSAL.text}
        onBackButtonClick={onBack}
      />
      <DownloadConfirmedProposalFiles />
      <PageFooter onBack={onBack} />
    </PageWrapperStyled>
  );
});

const DownloadConfirmedProposalPage: React.FC = () => {
  const { cartId } = useParams<{ periodId: string; groupId: string; cartId: string }>();

  const store = useMemo(
    () =>
      new PostSubmitDownloadProposalPageStore({
        cartId,
      }),
    [cartId],
  );

  return (
    <ProposalStatusLayout>
      <PostSubmitDownloadProposalPageStoreContext.Provider value={store}>
        <PageContent />
      </PostSubmitDownloadProposalPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default DownloadConfirmedProposalPage;
